import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import api from "../../services/api";
import AuthContext from "../../auth/context";
import { formatDateTime } from "../../helpers/time";

import {
  AppBar,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  Grid,
  IconButton,
  ListItem,
  ListItemText,
  styled,
  Toolbar,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import InfoIcon from "@mui/icons-material/Info";
import CustomizedSnackbars from "../../components/alert/Alert";

let text = "";
let tipo = "";

export default function Coordenacao(props) {
  const [alerta, setAlerta] = useState(false);
  const dados = props.location.state.dadosUnidade;
  const usuario = useContext(AuthContext);
  const history = useHistory();
  const [registros, setRegistros] = useState([]);
  const [itemSelecionado, setItemSelecionado] = useState("");

  useEffect(() => {
    carregarRegistros();
  }, []);

  const carregarRegistros = () => {
    api
      .get("relatorios/coordenacao", {
        unidadeId: dados.unidadeId,
        profissionalId: usuario.usuario.profissionalId,
      })
      .then((res) => {
        setRegistros(res);
      })
      .catch((e) => {
        console.log(e);

        const status = e.status;

        if (status === 400) {
          text =
            "Não foi possível obter o relatório. Verifique sua conexão e tente novamente.";
          tipo = "error";
          alertMsg();
        }
      });
  };

  const handleClose = () => {
    setItemSelecionado("");
  };

  const alertMsg = () => {
    setAlerta(true);
    setTimeout(() => setAlerta(false), 3000);
  };

  return (
    <div style={{ fontFamily: "Gilroy-ExtraBold" }}>
      <AppBar position="fixed">
        <Toolbar style={{ background: "#EC691A", color: "white" }}>
          <ArrowBackIcon
            onClick={() => history.push("lista")}
            style={{
              fontWeight: "bolder",
              marginRight: 20,
              cursor: "pointer",
            }}
          />
          <h2 style={{}}>Coordenação</h2>
        </Toolbar>
      </AppBar>

      <br />

      <Main
        style={{
          background: "white",
          fontFamily: "Gilroy-ExtraBold",
        }}
      >
        <Toolbar />
        <Grid style={{ background: "#a3a3a3", color: "white" }} xs={12}>
          <h2 style={{ marginLeft: 10 }}>
            {dados.cicloNome} {dados.unidadeNumero} - {dados.unidadeTitulo}
          </h2>
        </Grid>

        {registros.map((item, index) => (
          <>
            <br />
            <div style={{ padding: "0px 10px 0 10px" }}>
              <ListItem
                sx={{
                  width: "100%",
                  bgcolor: "#e8e8e8",

                  borderRadius: "20px",

                  cursor: "pointer",
                }}
                onClick={() => setItemSelecionado(item)}
              >
                <ListItemText
                  primary={
                    <h3 style={{ fontFamily: "Gilroy-ExtraBold" }}>
                      {item.usuarioNome}
                    </h3>
                  }
                  secondary={
                    <p
                      style={{
                        fontFamily: "Gilroy-ExtraBold",
                        color: definirCorSituacao(item.situacaoId),
                      }}
                    >
                      {item.situacao}
                    </p>
                  }
                />
                <IconButton
                  sx={{
                    background: "#a3a3a3",
                    color: "#FFFF",
                    marginRight: 2,
                  }}
                >
                  <InfoIcon />
                </IconButton>
              </ListItem>
            </div>
          </>
        ))}
        <br />
      </Main>

      <Dialog
        open={itemSelecionado}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <AppBar
          position="static"
          style={{ color: "white", background: "#6a7277" }}
        >
          <Toolbar>
            <Grid container>
              <Grid item xs={10} style={{ textAlign: "center" }}>
                <h2>{itemSelecionado.usuarioNome}</h2>
              </Grid>
              <Grid item xs={2}>
                <Button color="inherit" onClick={() => handleClose()}>
                  X
                </Button>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>

        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Grid
              container
              style={{ paddingLeft: 15, fontFamily: "Gilroy-ExtraBold" }}
            >
              <Grid item xs={12}>
                <h4>Previsão de ínicio</h4>
              </Grid>
              <br />
              <Grid item xs={12}>
                {formatDateTime(itemSelecionado.previsaoInicio, "D/M/Y")}
              </Grid>
              <br />
              <br />

              <Grid item xs={12}>
                <h4>Data/hora de ínicio</h4>
              </Grid>
              <br />
              <Grid item xs={12}>
                {itemSelecionado.inicio
                  ? formatDateTime(itemSelecionado.inicio, "D/M/Y h:m:s")
                  : "Não iniciado"}
              </Grid>
              <br />
              <br />

              <Grid item xs={12}>
                <h4>Previsão de término</h4>
              </Grid>
              <br />
              <Grid item xs={12}>
                {formatDateTime(itemSelecionado.previsaoTermino, "D/M/Y")}
              </Grid>
              <br />
              <br />

              <Grid item xs={12}>
                <h4>Situação</h4>
              </Grid>
              <br />
              <Grid
                style={{
                  color: definirCorSituacao(itemSelecionado.situacaoId),
                }}
                item
                xs={12}
              >
                {itemSelecionado.situacao}
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      {alerta && (
        <CustomizedSnackbars texto={text} tipo={tipo}></CustomizedSnackbars>
      )}
    </div>
  );
}

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    // padding: theme.spacing(1),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 250,
    }),
  })
);

const definirCorSituacao = (situacoaId) => {
  switch (situacoaId) {
    case 5:
      return "red";

    case 4:
      return "orange";

    case 3:
      return "green";

    default:
      return "black";
  }
};
